import GeneratedProjectTemplateStore from "./generated/GeneratedProjectTemplateStore"

class ProjectTemplateStore extends GeneratedProjectTemplateStore {

}

export const projectTemplateStore = new ProjectTemplateStore()
